// @flow
import { useContext, useMemo } from 'react';
import { AppContext } from 'contexts/AppContext';
import { UserContext } from 'contexts/UserContext';
import { useQuery } from 'react-query';
import { getAffordaDetails } from 'services/affordableService';
import useAbortController from 'hooks/useAbortController';
import QUERY_KEYS from 'constants/queryKeys';
import type { SectionsProgress } from 'hooks/sectionsProgress/types';

type AffordaDetails = {
  id: string,
  welcomeCompletedAt: string,
  termsAndConditionsAgreedAt: string,
  validationAttempts: number,
  lastValidationError: null,
  accountLockedAt: string,
  createdAt: string,
  updatedAt: string,
  deletedAt: string,
  organizationId: string,
  propertyId: string,
  portalUserId: string,
  sectionsProgress: SectionsProgress,
};
const useAffordaPortalDetailsQuery = ({ options = {} } = {}) => {
  const { organizationId, propertyId } = useContext(AppContext);
  const {
    authUser: { id },
  } = useContext(UserContext);
  const abortControllerOptions = useAbortController();

  const memoizedOptions = useMemo(() => {
    return {
      placeholderData: {},
      staleTime: 60000,
      enabled: Boolean(organizationId && propertyId && id),
      ...options,
    };
  }, [id, options, organizationId, propertyId]);

  return useQuery(
    QUERY_KEYS.affordaDetails({ authUserId: id }),
    async (): Promise<AffordaDetails> =>
      await getAffordaDetails(
        organizationId,
        propertyId,
        id,
        abortControllerOptions,
      ),
    memoizedOptions,
  );
};

export default useAffordaPortalDetailsQuery;
